//#region ../src/storage/byte-source.ts
/**
* A `ByteSource` whose backing can be swapped once, atomically, without the
* reader above it noticing. The size is fixed at construction — every source
* represents the same archive.
*/
var SwitchableByteSource = class {
	size;
	#current;
	#switched = false;
	constructor(initial) {
		this.#current = initial;
		this.size = initial.size;
	}
	read(offset, length) {
		return this.#current.read(offset, length);
	}
	/**
	* Swap the backing source. Only reads started *after* this see `next`, and
	* only the *first successful* call takes effect — a duplicate swap must not
	* re-fire. A source of a different size is refused (not counted as the one
	* swap): every parsed zip offset is anchored to `this.size`, so mismatched
	* bytes (redirect page, truncated body) would silently corrupt every later
	* read.
	*
	* Returns whether the swap took effect. A caller that just warmed a local
	* copy must know: `false` on a size mismatch means the downloaded bytes are
	* WRONG for this archive and must not be persisted to a cache.
	*/
	switchTo(next) {
		if (this.#switched || next.size !== this.size) return false;
		this.#switched = true;
		this.#current = next;
		return true;
	}
};
//#endregion
export { SwitchableByteSource };
